import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import MobileSort from "common/mobileSortField";
import "./style.scss";

const MobileDataTable = ({
  parentComponent,
  renderMobileTableRows,
  currentData,
  displaySearchFilter,
  expandedItems,
  handleSelectAll,
  sorting,
  onSorting,
  isSelectAllChecked,
  isPriceQuoteSearchTable,
}) => {
  const [sortValue, setSortValue] = useState("");
  const { fcRole } = useSelector((state) => state.loggedInUser);
  const customerTypeNode = useRef();
  const handleSortValues = (e, value) => {
    setSortValue(value);
  };

  return (
    <>
      {currentData.length > 0 ? (
        <div className={`${parentComponent === "priceQuote" ? "priceQuoteTable" : "mobile-data"} d-md-none d-lg-none`}>
          {parentComponent === "laborTable" && (
            <div className="sort">
              <MobileSort
                inputRef={customerTypeNode}
                options={expandedItems}
                label="Sort by"
                defaultValue="Select a Type"
                value={sortValue}
                sorting={sorting}
                onSorting={onSorting}
                handleSelectInput={(e, value) => handleSortValues(e, value)}
              />
            </div>
          )}
          {parentComponent === "accountLookup" && (
            <div className="sort">
              <MobileSort
                inputRef={customerTypeNode}
                options={expandedItems}
                label="Sort by"
                defaultValue="Select a Type"
                value={sortValue}
                sorting={sorting}
                onSorting={onSorting}
                handleSelectInput={(e, value) => handleSortValues(e, value)}
              />
            </div>
          )}

          {parentComponent === "siteRepoSearch" && (
            <div className="sort">
              <MobileSort
                inputRef={customerTypeNode}
                options={expandedItems}
                label="Sort by"
                defaultValue="Select a Type"
                value={sortValue}
                sorting={sorting}
                onSorting={onSorting}
                handleSelectInput={(e, value) => handleSortValues(e, value)}
              />
            </div>
          )}
          <div className="row mobile-data__row">
            <div className="col-sm-12 mobile-data__row__column">
              {(displaySearchFilter || parentComponent === "priceQuote") &&
                !isPriceQuoteSearchTable &&
                fcRole !== "FcStoreManager" &&
                parentComponent === "laborTable" && (
                  <div className="d-flex mobile-data__row__column__select-all">
                    <div className="mobile-data__row__column__select-all__input">
                      <input
                        type="checkbox"
                        aria-label="Checkbox for following text input"
                        className="mobile-data__row__column__select-all__input--field"
                        onChange={handleSelectAll}
                        checked={isSelectAllChecked}
                      />
                    </div>
                    <div className="mobile-data__row__column__select-all--text">
                      {parentComponent === "priceQuote" ? "Apply Tax Rate to all" : "Select All"}
                    </div>
                  </div>
                )}
              {renderMobileTableRows ? renderMobileTableRows(currentData, parentComponent) : <></>}
            </div>
          </div>
        </div>
      ) : displaySearchFilter ? (
        <div className="d-md-none d-lg-none no-results d-flex flex-column text-center">
          <div className="no-results--text">No results found</div>
          <div className="no-results--info">Try adjusting your search or filter to what you are looking for</div>
        </div>
      ) : (
        <div className="d-md-none d-lg-none no-results no-results--text text-center">
          Zero results were found based on your search criteria.
        </div>
      )}
    </>
  );
};
export default MobileDataTable;
